import { createSelector } from 'reselect'

import { IOnboardingState } from '../models'

export const selectIsDataUploadedForTransitionsMapping = (state: {
  onboarding: IOnboardingState
}) => state.onboarding.commonData.isDataUploadedForTransitionsMapping

export const selectContactsWithMultiplePartnersData = (state: { onboarding: IOnboardingState }) =>
  state.onboarding.commonData.contactsWithMultiplePartners

export const selectContactsWithMultiplePartnersLoadingStatus = createSelector(
  [selectContactsWithMultiplePartnersData],
  ({ status }) => status
)

export const selectRefreshContactDataTrigger = (state: { onboarding: IOnboardingState }) =>
  state.onboarding.commonData.refreshContactDataTrigger
